module.exports = __webpack_public_path__ + "static/media/integration-tools.a8d30aa4.svg";